export default __webpack_public_path__ + "static/media/benefits_desc1mx.edd089c9.png";